import { render, staticRenderFns } from "./list-approval.vue?vue&type=template&id=26603477&"
import script from "./list-approval.vue?vue&type=script&lang=js&"
export * from "./list-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports